import React from 'react';
import Daniel from '../assets/Daniel2.jpg';
import William from '../assets/william.jpg';
import Sid from '../assets/Sid.jpg';

import Abhinav from '../assets/coach2.svg';

const Coaches = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        <h1>Meet Our Chess Coaches</h1>
        <p className="lead">Passionate experts dedicated to your success.</p>
      </div>

      {/* Coach 1 Section */}
      <div className="row align-items-center coach-section">
        <div className="col-md-4 text-center coach-img-container">
          <div className="coach-img-frame">
            <img src={Daniel} alt="Daniel Polonsky" className="coach-actual-img coach-daniel-img" />
          </div>
        </div>
        <div className="col-md-8">
          <h3>Daniel Polonsky - Head Chess Coach and Owner</h3>
          <div className="coach-details">
            <h5>What Students Say</h5>
            <blockquote className="blockquote">
              <p>"Because of Daniel, my son is more confident in playing chess, and he can't wait for each class."</p>
            </blockquote>
            <blockquote className="blockquote">
              <p>"I couldn't have asked for a better teacher to teach my child chess. Daniel has been a positive influence, and I highly recommend him for anyone looking for a chess teacher for their child."</p>
            </blockquote>
            <blockquote className="blockquote">
              <p>"Daniel's been an incredible chess mentor for my 12-year-old son. Since working with him, my son's chess game has shot through the roof. Daniel's passion for chess is contagious, and he's sparked an excitement in my son to play and train."</p>
            </blockquote>
            <h5>Achievements & Qualifications</h5>
            <ul>
              <li>Chess.com Rating: 2056</li>
              <li>3+ Years of Coaching Experience</li>
              <li>Dedicated to fostering a love for the game</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Coach 2 Section */}
      <div className="row align-items-center coach-section">
        <div className="col-md-4 text-center coach-img-container">
          <div className="coach-img-frame">
            <img src={William} alt="William Sweeney" className="coach-actual-img coach-william-img" />
          </div>
        </div>
        <div className="col-md-8">
          <h3>William Sweeney - Chess Coach</h3>
          <p>William is a patient and experienced coach who excels at helping students build a strong foundation in chess.</p>
          <div className="coach-details">
            <h5>Achievements & Qualifications</h5>
            <ul>
              <li>Chess.com Rating: 2130</li>
              <li>2+ Years of Teaching Experience</li>
              <li>Renowned for innovative endgame strategies and positional play</li>
              <li>Passionate about fostering deep understanding and love for chess</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Coach 3 Section */}
      <div className="row align-items-center coach-section">
        <div className="col-md-4 text-center coach-img-container">
          <div className="coach-img-frame">
            <img src={Sid} alt="Sid Siddem" className="coach-actual-img coach-sid-img" />
          </div>
        </div>
        <div className="col-md-8">
          <h3>Sid Siddem - Head Tournament Director and Chess Coach</h3>
          <p>Sid is a 2040 rated player with a year of teaching experience and two years of experience hosting major chess tournaments in the greater Seattle area for all levels.</p>
          <div className="coach-details">
            <h5>What Students Say</h5>
            <blockquote className="blockquote">
              <p>"Really fun events, and smoothly run! Definitely coming to next event!"</p>
              <footer className="blockquote-footer">Andrew F.</footer>
            </blockquote>
            <blockquote className="blockquote">
              <p>"Always enjoy coming to these tournaments, many people always show up of different skill levels, and the venue and direction of the tournaments are amazing!"</p>
              <footer className="blockquote-footer">Kiann S.</footer>
            </blockquote>
            <blockquote className="blockquote">
              <p>"Fun chess tournaments, and challenges for all rating levels. Good mix of higher and lower rated participants and the rounds are quick and well directed!"</p>
              <footer className="blockquote-footer">Ihsan M.</footer>
            </blockquote>
            <h5>Achievements & Qualifications</h5>
            <ul>
              <li>USCF National Tournament Director</li>
              <li>Chess.com Rating: 2040</li>
              <li>1 Year of Teaching Experience</li>
              <li>2 Years of Tournament Directing</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Coach 4 Section - Hidden
      <div className="row align-items-center coach-section">
        <div className="col-md-4 text-center">
          <div className="coach-img-frame">
            <img src={Abhinav} alt="Abhinav Mishra" className="coach-actual-img" />
          </div>
        </div>
        <div className="col-md-8">
          <h3>Abhinav Mishra - Coach</h3>
          <div className="coach-details">
            <h5>Impressive Achievements & Expertise</h5>
            <ul>
              <li>FIDE Master (FM) with a focus on tactical brilliance</li>
              <li>Specializes in developing aggressive and creative playstyles</li>
              <li>Proven track record of improving student's tactical vision</li>
              <li>Dedicated to making complex chess concepts accessible and fun</li>
            </ul>
          </div>
        </div>
      </div>
      */}
    </div>
  );
};

export default Coaches;
